"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _youtube = _interopRequireDefault(require("./youtube.theme"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var youtube = {
  app: {
    atomicPublisherUnit: "channel",
    atomicFollowerUnit: "subscriber",
    url_count_limit: 65000
  },
  brand: {
    codename: "youtube",
    name: "YouTube",
    color: _youtube["default"].tenant.primary,
    logoProps: {
      name: "youtubeLogo"
    }
  },
  exclusionGroupCatalog: {
    headerColor: "black",
    headerIcon: "modelBuilder"
  },
  engagementManager: {
    headerColor: "turquoise",
    headerIcon: "engagementManager",
    providerLink: {
      providerExternalIdLabel: "Campaign ID",
      linkType: "account"
    }
  },
  campaignManager: {
    headerColor: "turquoise",
    headerIcon: "engagementManager",
    title: "Youtube Engagement Search"
  },
  profile: {
    headerColor: "purple",
    header: {
      suitability: {
        requiredPermissions: ["view_suitability_ratings"]
      }
    },
    profileMetrics: [{
      title: "Subscribers",
      dataKey: "fan_count"
    }, {
      title: "Videos",
      dataKey: "video_count"
    }, {
      title: "Video Views",
      dataKey: "views_sum"
    }],
    videoMetrics: [{
      title: "Monthly Views",
      dataKey: "monthly_views"
    }, {
      title: "Likes Per Video",
      dataKey: "like_count_avg"
    }, {
      title: "Avg Length",
      dataKey: "duration_seconds_avg",
      type: "duration"
    }],
    videosGrid: {
      tabs: [{
        title: "Most Recent",
        icon: "today",
        dataKey: "mostRecent",
        order: "pub_date",
        query: {
          ordering: "-pub_date"
        }
      }, {
        title: "Most Watched",
        icon: "remove_red_eye",
        dataKey: "mostEngaged",
        order: "engagement_count",
        query: {
          ordering: "-view_count"
        }
      }, {
        title: "High Risk",
        icon: "warning",
        dataKey: "highRisk",
        order: "risk_sort_only",
        requiredPermissions: ["view_suitability_ratings"],
        query: {
          ordering: "-pub_date",
          brandsafety_video_label: "High Risk"
        }
      }],
      thumbnailMetrics: [{
        label: "Views",
        dataKey: "view_count",
        type: "number"
      }, {
        label: "Published",
        dataKey: "pub_date",
        type: "date"
      }]
    },
    tags: {
      title: "Top Tags"
    }
  },
  mainCatalog: {
    headerColor: "purple",
    headerIcon: "ribbon",
    experimentalSearchEnabled: true,
    experimentalSearchOptions: [{
      label: "Low Frequency",
      value: "low_frequency"
    }, {
      label: "Min Term Frequency",
      value: "mintermfreq"
    }],
    featuredMetrics: [{
      label: "Monthly Views",
      dataKey: "monthly_views_sum",
      icon: "monthlyViews"
    }, {
      label: "Channels",
      dataKey: "count",
      icon: "channel"
    }, {
      label: "Videos",
      dataKey: "video_count_sum",
      icon: "videosTriangle"
    }],
    facets: [{
      label: "Quality",
      filters: ["SlateScoreFilter"]
    }, {
      label: "Suitability Ratings",
      filters: ["SuitabilityFilter"],
      tooltip: "SuitabilityDescriptionList",
      requiredPermissions: [],
      excludedLabels: ["Inflammatory News & Politics"]
    }, {
      label: "Primary Category",
      filters: ["ContentCategoryFilter"]
    }, {
      label: "Geo Settings",
      filters: ["GeoFilter"]
    }, {
      label: "Audience",
      filters: ["FanCountFilter", {
        label: "Monthly Views",
        type: "MonthlyViewsFilter",
        queryParam: "monthly_views__range",
        aggregatesKey: "monthly_views"
      }]
    }],
    table: {
      showDownloadAll: true,
      downloadAllRequiredPermissions: ["export_profiles_catalog"],
      defaultSortOrder: "-monthly_views",
      downloadFields: ["title", "status", "language_label", "location_label", "monthly_views", "fan_count", "video_count", "suitability", "suitability_categories_labels", "unified_slatescore"
      //    ...other fields
      ],
      permissionBasedDefaultFacets: [{
        requiredPermissions: [],
        filterKey: "language_label",
        filterValue: "English"
      }, {
        requiredPermissions: ["view_suitability_ratings"],
        filterKey: "language_label",
        filterValue: null
      }, {
        requiredPermissions: [],
        filterKey: "suitability",
        filterValue: null
      }, {
        requiredPermissions: ["view_suitability_ratings"],
        filterKey: "suitability",
        filterValue: ["GS", "MS", "NS"]
      }],
      columns: [{
        dataKey: "picture",
        cellType: "picture"
      }, {
        label: "Name",
        dataKey: "title",
        cellType: "title"
      }, {
        label: "Primary Category",
        dataKey: "category"
      }, {
        label: "Language",
        dataKey: "language_label"
      }, {
        label: "Location",
        dataKey: "location_label"
      }, {
        label: "DV Media Score",
        dataKey: "unified_slatescore",
        cellType: "slateScore"
      }, {
        label: "Suitability",
        dataKey: "suitability",
        cellType: "suitability",
        sorting: false,
        requiredPermissions: ["view_suitability_ratings"]
      }, {
        label: "Subscribers",
        dataKey: "fan_count",
        cellType: "number"
      }, {
        label: "Videos",
        dataKey: "video_count",
        cellType: "number"
      }, {
        label: "Monthly Views",
        dataKey: "monthly_views",
        cellType: "number",
        tooltip: "Total views for the past 30 days",
        "default": true
      }]
    }
  },
  osControl: {
    headerColor: "black",
    headerIcon: "target",
    experimentalSearchOptions: [{
      label: "Low Frequency",
      value: "low_frequency"
    }, {
      label: "Min Term Frequency",
      value: "mintermfreq"
    }],
    featuredMetrics: [{
      label: "Monthly Views",
      dataKey: "monthly_views_sum",
      icon: "monthlyViews"
    }, {
      label: "Channels",
      dataKey: "count",
      icon: "channel"
    }, {
      label: "Videos",
      dataKey: "video_count_sum",
      icon: "videosTriangle"
    }],
    facets: [{
      label: "Quality",
      filters: ["SlateScoreFilter"]
    }, {
      label: "Suitability Ratings",
      filters: ["SuitabilityFilter"],
      tooltip: "SuitabilityDescriptionList",
      requiredPermissions: ["view_suitability_ratings"]
      // setting to exclude a suitibility rating
      // excludedLabels: ["Inflammatory News & Politics"]
    }, {
      label: "Primary Category",
      filters: ["ContentCategoryFilter"]
    }, {
      label: "Audience",
      filters: ["FanCountFilter", {
        label: "Monthly Views",
        type: "MonthlyViewsFilter",
        queryParam: "monthly_views__range",
        aggregatesKey: "monthly_views"
      }, "LanguageFilter"]
    }],
    table: {
      defaultSortOrder: "-monthly_views",
      permissionBasedDefaultFacets: [],
      columns: [{
        dataKey: "picture",
        cellType: "picture",
        externalLink: true
      }, {
        label: "Name",
        dataKey: "title",
        cellType: "title",
        externalLink: true
      }, {
        label: "Primary Category",
        dataKey: "category"
      }, {
        label: "DV Media Score",
        dataKey: "unified_slatescore",
        cellType: "slateScore"
      }, {
        label: "Suitability",
        dataKey: "suitability",
        cellType: "suitability",
        sorting: false,
        requiredPermissions: ["view_suitability_ratings"]
      }, {
        label: "Subscribers",
        dataKey: "fan_count",
        cellType: "number"
      }, {
        label: "Videos",
        dataKey: "video_count",
        cellType: "number"
      }, {
        label: "Monthly Views",
        dataKey: "monthly_views",
        cellType: "number",
        tooltip: "Total views for the past 30 days",
        "default": true
      }, {
        label: "Remove",
        dataKey: "id",
        sorting: false,
        cellType: "removeFromSlate"
      }]
    }
  },
  videoCatalog: {
    header: {
      showHighRisk: {
        requiredPermissions: ["view_suitability_ratings"]
      }
    },
    table: {
      columns: [{
        dataKey: "thumbnail",
        cellType: "videoThumbnail"
      }, {
        label: "Title",
        dataKey: "title",
        cellType: "videoTitle"
      }, {
        label: "Views",
        dataKey: "view_count",
        cellType: "number"
      }, {
        label: "Publish Date",
        dataKey: "pub_date",
        cellType: "date"
      }, {
        label: "Risk Flag",
        dataKey: "brandsafety_video_label",
        cellType: "highRiskFlag",
        requiredPermissions: ["view_suitability_ratings"]
      }]
    }
  },
  videoPlayer: {
    calculateAspectRatio: true,
    videoStats: [{
      label: "Likes",
      dataKey: "like_count"
    }, {
      label: "Views",
      dataKey: "view_count"
    }, {
      label: "Comments",
      dataKey: "comment_count"
    }],
    externalLink: {
      label: "View on YouTube",
      iconProps: {
        name: "youtubeLogo"
      }
    }
  },
  charts: {
    engagements: {
      title: "Engagement",
      subheading: "Average engagements (likes + dislikes + comments) per video",
      xAxisLabel: "Number of likes, dislikes and comments",
      verbosedLabels: {
        _page: "This Channel",
        _category: "Channels with Same Primary Category",
        _all: "Platform Avg."
      }
    },
    publishingCadence: {
      title: "Publishing Cadence",
      subheading: "Videos published over the last 12 weeks (by week)",
      legendOverallAvg: "Platform Avg.",
      legendThisPage: "This Channel",
      legendPrimaryCateory: "Channels with Same Primary Category",
      yAxisLabel: "Number of videos",
      xAxisLabel: "Weeks"
    },
    length: {
      title: "Video Length",
      subheading: "Average video length in seconds",
      xAxisLabel: "Video length (sec.)",
      verbosedLabels: {
        _page: "This Channel",
        _category: "Channels with Same Primary Category",
        _all: "Platform Avg."
      }
    }
  },
  navigationMenu: [{
    label: "DV Ratings",
    iconProps: {
      name: "contentRatings"
    },
    routeRef: "mainCatalog",
    routeRefMatches: ["mainCatalog", "profile", "profileVideos"]
  }, {
    label: "Engagements Manager",
    iconProps: {
      name: "engagementManager"
    },
    routeRef: "engagementManager",
    routeRefMatches: ["engagementManager", "engagementListEdit"]
  }, {
    label: "Campaign Manager",
    iconProps: {
      name: "campaignManager"
    },
    routeRef: "campaignManager",
    routeRefMatches: ["campaignManager"]
  }, {
    label: "Exclusion Groups",
    iconProps: {
      name: "exclusionGroup"
    },
    routeRef: "exclusionGroupCatalog",
    routeRefMatches: ["exclusionGroupCatalog"]
  }, {
    label: "DV Intelligence",
    iconProps: {
      name: "reports"
    },
    routeRef: "reportCatalog",
    routeRefMatches: ["reportCatalog"]
  }, {
    label: "DV Targeting Controls",
    iconProps: {
      name: "reports"
    },
    routeRef: "slateCatalog",
    routeRefMatches: ["slateCatalog", "slate"]
  }],
  modelBuilder: {
    listMetrics: [{
      label: "Channels",
      dataKey: "count"
    }, {
      label: "Videos",
      dataKey: "video_count_sum"
    }]
  },
  reporting: {
    headerColor: "berry",
    headerIcon: "chart",
    reportTypes: [{
      reportType: "adwords_mcc",
      downloadLinks: [{
        label: "Report Files",
        downloadReportType: "output_zip"
      }, {
        label: "Low Touch PPT",
        downloadReportType: "lowtouch_ppt"
      }]
    }, {
      reportType: "dbm_csv",
      downloadLinks: [{
        label: "Report Files",
        downloadReportType: "output_zip"
      }, {
        label: "Low Touch PPT",
        downloadReportType: "lowtouch_ppt"
      }]
    }, {
      reportType: "generic_channel_csv",
      downloadLinks: [{
        label: "CSV",
        downloadReportType: "csv_output"
      }]
    }, {
      reportType: "generic_video_csv",
      downloadLinks: [{
        label: "CSV",
        downloadReportType: "csv_output"
      }]
    }, {
      reportType: "yt_csv_entity",
      downloadLinks: [{
        label: "Report Files",
        downloadReportType: "output_zip"
      }, {
        label: "Low Touch PPT",
        downloadReportType: "lowtouch_ppt"
      }]
    }, {
      reportType: "yt_api_entity",
      downloadLinks: [{
        label: "Report Files",
        downloadReportType: "output_zip"
      }, {
        label: "Low Touch PPT",
        downloadReportType: "lowtouch_ppt"
      }]
    }, {
      reportType: "yt_api_entity_video",
      downloadLinks: [{
        label: "Report Files",
        downloadReportType: "output_zip"
      }, {
        label: "Low Touch PPT",
        downloadReportType: "lowtouch_ppt"
      }]
    }, {
      reportType: "yt_csv_no_entity",
      downloadLinks: [{
        label: "Report Files",
        downloadReportType: "output_zip"
      }, {
        label: "Low Touch PPT",
        downloadReportType: "lowtouch_ppt"
      }]
    }, {
      reportType: "yt_csv_entity_video",
      downloadLinks: [{
        label: "Report Files",
        downloadReportType: "output_zip"
      }, {
        label: "Low Touch PPT",
        downloadReportType: "lowtouch_ppt"
      }]
    }, {
      reportType: "yt_csv_no_entity_video",
      downloadLinks: [{
        label: "Report Files",
        downloadReportType: "output_zip"
      }, {
        label: "Low Touch PPT",
        downloadReportType: "lowtouch_ppt"
      }]
    }, {
      reportType: "yt_csv_portfolio_report",
      downloadLinks: [{
        label: "CSV",
        downloadReportType: "csv_output"
      }]
    }, {
      reportType: "yt_csv_no_entity_video_join",
      downloadLinks: [{
        label: "CSV",
        downloadReportType: "csv_output"
      }]
    }, {
      reportType: "yt_csv_no_entity_channel_join",
      downloadLinks: [{
        label: "CSV",
        downloadReportType: "csv_output"
      }]
    }]
  },
  channelIngest: {
    headerIcon: "targeting",
    headerColor: "turquoise"
  },
  slateActivation: {
    headerIcon: "targeting",
    headerColor: "turquoise"
  },
  routes: {
    home: {
      url: "/",
      title: "Home"
    },
    mainCatalog: {
      url: "/channels",
      title: "DV Content Settings",
      requiredPermissions: ["view_profiles_catalog"],
      component: "MainCatalog",
      "default": true
    },
    profile: {
      url: "/channels/:id",
      requiredPermissions: ["view_profile"],
      title: "DV Content Settings",
      component: "Profile"
    },
    profileVideos: {
      url: "/channels/:id/videos",
      title: "DV Content Settings",
      requiredPermissions: ["view_videos_catalog"],
      component: "Profile"
    },
    reporting: {
      component: "ReportCatalog",
      requiredPermissions: ["view_reports_catalog"],
      title: "DV Intelligence",
      url: "/reports"
    },
    channelIngest: {
      component: "ChannelIngest",
      requiredPermissions: ["add_channel_file_ingest"],
      title: "Channel Ingest",
      url: "/channel-ingest"
    },
    engagementManager: {
      component: "EngagementManager",
      requiredPermissions: ["view_engagement"],
      title: "DV Engagements",
      url: "/engagements-manager"
    },
    engagementListEdit: {
      component: "EngagementListEdit",
      requiredPermissions: ["change_engagement_list"],
      title: "Model Builder",
      url: "/engagements-manager/model/:id"
    },
    exclusionGroupCatalog: {
      component: "ExclusionGroupsCatalog",
      requiredPermissions: ["view_target_sets_catalog"],
      title: "Exclusion Groups",
      url: "/exclusion-groups"
    },
    slate: {
      component: "Slate",
      requiredPermissions: ["view_os_control"],
      title: "DV Targeting Controls",
      url: "/lists/:id"
    },
    osControl: {
      component: "SlateCatalog",
      requiredPermissions: ["view_os_control"],
      title: "DV Targeting Control",
      url: "/lists"
    },
    slateActivation: {
      title: "DV360 YouTube Pre-Screen Activation Tool",
      hostname: "targeting",
      url: "/targeting",
      requiredPermissions: ["view_targeted_sdf"]
    },
    terms: {
      component: "Terms",
      title: "DV Terms and Conditions",
      url: "/terms"
    }
  },
  breadcrumbs: {
    'campaign-manager': {
      title: "Campaign Manager",
      url: "/campaign-manager"
    },
    'shared-library': {
      title: "Shared Library",
      url: "/campaign-manager/shared-libraries"
    },
    'shared-libraries': {
      title: "Shared Libraries",
      url: "/campaign-manager/shared-libraries"
    }
    // ':id': {
    //   title: "Youtube Campaign Manager Shared Library",
    //   url: "/campaign-manager/shared-library/:id"
    // }
  }
};
var _default = exports["default"] = youtube;